var exports = {
  "k": "x43aef4ae--ccb488--container",
};

module.exports = exports;
